import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=2f7867c0&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=2f7867c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7867c0",
  null
  
)

export default component.exports